import {
  Button,
  DialogFooterV2,
  Inset,
  Spinner,
  useCloseDialog,
  Typography,
  Stack,
} from '@cast/design-system';

export const InProgressSlide = () => {
  const closeDialog = useCloseDialog();

  return (
    <div data-testid="import-in-progress-slide">
      <Inset>
        <Stack direction="row" gap={12}>
          <div>
            <Spinner color="primary" size={32} />
          </div>
          <Stack gap="4px">
            <Typography variant="h6">This might take a while...</Typography>
            <Typography variant="P12R" color="textSecondary">
              Once commitments have been uploaded, they will be listed on this
              page. You can close this window now.
            </Typography>
          </Stack>
        </Stack>
      </Inset>
      <DialogFooterV2
        endContent={
          <Button
            variant="primary"
            onClick={() => closeDialog()}
            testId="close-button"
          >
            Close
          </Button>
        }
      />
    </div>
  );
};
